<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <section class="hero-section ptb-100 background-img" style="background: url('/static/img/hero-bg-canchas.jpg')no-repeat center center / cover">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-9 col-lg-7">
                    <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                        <h1 class="text-white mb-0">Registro</h1>
                        <div class="custom-breadcrumb">
                            <ol class="breadcrumb d-inline-block bg-transparent list-inline py-0">
                                <li class="list-inline-item breadcrumb-item"><a href="#">Llena tus datos y realiza el pago para completar tu inscripción.</a></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="steps-header">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-10">
                    <el-steps :active="active" finish-status="success" align-center>
                        <el-step title="Escuela y horario"></el-step>
                        <el-step title="Datos del alumno"></el-step>
                        <el-step title="Datos de facturación"></el-step>
                    </el-steps>
                </div>
            </div>
        </div>
    </section>
    <section class="customer-review-section ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-10">
                  <div class="ep-step-one">

                  </div>
                  <div class="ep-step-two">

                  </div>
                  <div class="ep-step-tree">

                  </div>


                    <button class="btn outline-btn my-5" style="margin-left: 90px;" @click="next">Siguiente</button>
                </div>
            </div>
        </div>
    </section>

</div>
</template>

<script>
export default {
    data() {
        return {
            active: 0
        }
    },
    methods: {
        next() {
            if (this.active++ > 2) this.active = 0;
        }
    }
}
</script>

<style>
.el-step__title.is-process,.el-step__head.is-process {
    color: #1A4A84 !important;
}
.el-step__head.is-process{border-color: #1A4A84}
.steps-header{
  padding: 20px; background:#fafafa;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/epresencial/register.vue